var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"sanadeus"}},[(_vm.validView)?_c(_vm.layout,{tag:"component"}):_c('div',[_vm._v("Sie können diese Ansicht nicht aufrufen.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }